import React from "react";
import Objectives from "./Objectives";

const Home = () => {
  return (
    <>
      <section className="overflow-hidden bg-[url(https://imgs.search.brave.com/ksC_5vsc5mXKw75-39yikuKzpzwgCob32FhazosDTRI/rs:fit:1150:480:1/g:ce/aHR0cHM6Ly9ibG9n/LnR1Zi5lZHUucGsv/d3AtY29udGVudC91/cGxvYWRzLzIwMjEv/MDcvQUkuanBn)] bg-cover bg-center bg-no-repeat sm:py-15">
        <div className="bg-black/50 p-8 md:p-12 lg:px-16 lg:py-24">
          <div className="max-w-lg text-center sm:text-left">
            <h2 className="text-2xl font-bold text-white sm:text-3xl md:text-5xl">
              Welcome to Artificial Intelligence & Deep Learning Lab @S.P.I.T.
            </h2>

            <p className="hidden max-w-md text-white/90 md:mt-6 md:block md:text-lg md:leading-relaxed">
              Get started with exciting experiments to enrich your knowledge
            </p>
          </div>
        </div>
      </section>

      <Objectives />
    </>
  );
};

export default Home;
